import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './store';
import { HelmetProvider } from 'react-helmet-async';
import store from './store';
import AuthSessionSync from './components/AuthSessionSync';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <CookiesProvider>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <AuthSessionSync />
                        <App />
                    </PersistGate>
                </Provider>
            </CookiesProvider>
        </HelmetProvider>
    </React.StrictMode>
);
